import React from "react";
import { useAppSelector } from "../../../app/store";
import { AssetClassification } from "../../../api/credit_account_current_positions";
import { getAccountDetailByAccountNumber } from "../../creditAccounts/logic/slice";
import AssetClassificationPill from "./AssetClassificationPill";

interface AccountSummaryCardProps {
  accountNumber: string;
}

const AccountSummaryCard: React.FC<AccountSummaryCardProps> = ({
  accountNumber,
}) => {
  const accountDetails = useAppSelector((state) =>
    getAccountDetailByAccountNumber(state, accountNumber),
  );

  if (!accountDetails) {
    return null;
  }

  const { account, accountOverview } = accountDetails;
  const selectedAccountNumber =
    account?.account_number ?? accountOverview?.account_number;
  const displayAccountNumber = account.ext_account_number;

  if (!selectedAccountNumber) {
    return null;
  }

  const name = account?.account_name;
  const product = account?.product;
  const assetClassification =
    accountOverview?.current_position?.asset_classification;

  return (
    <div className="flex w-full items-center justify-between px-4">
      <div className="flex min-w-0 flex-col gap-1">
        <span className="truncate text-[14px] font-medium leading-5 text-[#0A0A0A]">
          {name || "--"}
        </span>

        <span
          className="truncate text-xs font-normal leading-4 text-[#737373]"
          title={`${displayAccountNumber} • ${product || "--"}`}
        >
          {displayAccountNumber}
          {" • "}
          {product || "--"}
        </span>
      </div>

      <div className="ml-4 shrink-0">
        <AssetClassificationPill
          value={assetClassification}
        />
      </div>
    </div>
  );
};

export default AccountSummaryCard;